import { render, staticRenderFns } from "./EditAforoAcces.vue?vue&type=template&id=2fc9f686&"
import script from "./EditAforoAcces.vue?vue&type=script&lang=js&"
export * from "./EditAforoAcces.vue?vue&type=script&lang=js&"
import style0 from "./EditAforoAcces.vue?vue&type=style&index=0&id=2fc9f686&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports